// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"965":"home-lang-el","3895":"home-lang-en"}[chunkId] + "." + {"965":"4f2c39c9","3895":"5713db23"}[chunkId] + ".js";
};